import { render, staticRenderFns } from "./FilteredEmails.vue?vue&type=template&id=084b6fb7&scoped=true&"
import script from "./FilteredEmails.vue?vue&type=script&lang=js&"
export * from "./FilteredEmails.vue?vue&type=script&lang=js&"
import style0 from "./FilteredEmails.vue?vue&type=style&index=0&id=084b6fb7&prod&lang=css&"
import style1 from "./FilteredEmails.vue?vue&type=style&index=1&id=084b6fb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b6fb7",
  null
  
)

export default component.exports